import { render, staticRenderFns } from "./CmsGeneralForm.vue?vue&type=template&id=efd9f898&scoped=true&"
import script from "./CmsGeneralForm.vue?vue&type=script&lang=js&"
export * from "./CmsGeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./CmsGeneralForm.vue?vue&type=style&index=0&id=efd9f898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd9f898",
  null
  
)

export default component.exports